// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

// JS
import 'bootstrap'

// CSS
import "@fortawesome/fontawesome-free/css/all.css"
import 'stylesheets/application'

$(document).ready(() => {
  let turmasInclusas = [];
  let turmas = [];

  function encontrarIndicesSubstring(str, substr) {
    const indices = [];
    let pos = 0;

    while (true) {
      const index = str.indexOf(substr, pos);
      if (index === -1) break;
      indices.push(index);
      pos = index + 1; // Avança 1 para permitir sobreposição (ex: "ana" em "anana")
    }

    return indices;
  }


  function getNomeAmbiente() {
    if (turmasInclusas.length === 0) {
      return '';
    }

    const primeiraTurmaInclusa = turmasInclusas[0];
    const posicoesEspacador = encontrarIndicesSubstring(primeiraTurmaInclusa, ' - ');
    const primeiraDisciplina = primeiraTurmaInclusa.substring(posicoesEspacador[1] + 3, posicoesEspacador[posicoesEspacador.length - 1]);
    const primeiraTurma = primeiraTurmaInclusa.substring(posicoesEspacador[posicoesEspacador.length - 1] + 3);

    if (turmasInclusas.length === 1) {
      return primeiraDisciplina + ' - ' + primeiraTurma;
    }

    return primeiraDisciplina + ' - VÁRIAS TURMAS';
  }

  function getNomeBreve() {
    if (turmasInclusas.length === 0) {
      return '';
    }

    const anoPeriodo = $('#ano_periodo').text();
    const disciplinasTurmas = turmasInclusas.map((disciplinaTurma) => {
      const partes = disciplinaTurma.split(' - ');
      const codigoTurma = partes[partes.length - 1].split(' ')[1]; // Exemplo: Turma M retorna apenas M

      return partes[1] + '-' + codigoTurma;
    });

    return disciplinasTurmas.join(" ") + ' ' + anoPeriodo;
  }

  $('[data-toggle="tooltip"]').tooltip();

  // **********************
  //
  // Popover para auxiliar o usuário sobre o sistema
  //
  // **********************

  if(window.location.pathname != "/sicam/ambientes/novo") {
    $("#novo-ambiente-link").popover({
      content: "Clique aqui para criar um novo ambiente de graduação no AVA.",
      trigger: "manual",
      placement: "bottom"
    });

    $("#novo-ambiente-link").popover('show');

    $('#novo-ambiente-link').on('mouseenter', function() {
      $("#novo-ambiente-link").popover('show');
    }).on('mouseleave', function() {
      $("#novo-ambiente-link").popover('hide');
    });
  }

  $("#tabela-ambientes-ava").popover({
    content: "Aqui são listados os ambientes que já foram criados no AVA.",
    trigger: "manual",
    placement: "top"
  });

  $("#tabela-ambientes-ava").popover('show');

  $('#tabela-ambientes-ava').on('mouseenter', function() {
    $("#tabela-ambientes-ava").popover('show');
  }).on('mouseleave', function() {
    $("#tabela-ambientes-ava").popover('hide');
  });


  $('#first-element-turma-add').popover({
    content: "Você pode adicionar mais de uma turma no mesmo ambiente AVA. Apenas adicione turmas que sejam da mesma disciplina.",
    trigger: "manual",
    placement: "top"
  });

  $('#first-element-turma-add').popover('show');

  $('.btn-add-ambiente').popover({
    content: "Você pode adicionar mais de uma turma no mesmo ambiente AVA. Apenas adicione turmas que sejam da mesma disciplina.",
    trigger: "manual",
    placement: "top"
  });

  $('.btn-add-ambiente').on('mouseenter', function() {
    $('#first-element-turma-add').popover('hide');
    $(this).popover('show');
  }).on('mouseleave', function() {
    $(this).popover('hide');
  });



  setTimeout(function () {
    $("#first-element-turma-add").popover('hide');
    $("#novo-ambiente-link").popover('hide');
    $("#tabela-ambientes-ava").popover('hide');
  }, 6000);

  // ***************************
  //
  // Fim do Popover
  //
  // ***************************

  $('.btn-add-ambiente').on('click', function() {
    const curso = $(this).data('curso');
    const disciplina = $(this).data('disciplina');
    const codigo = $(this).data('codigo');
    const turma = $(this).data('turma');
    const idTurma = $(this).data('id-turma');
    const turmaAno = $(this).data('turma-ano');
    const turmaPeriodo = $(this).data('turma-periodo');
    const turmaInclusa = turmaAno + '.' + turmaPeriodo + ' - ' + codigo + ' - ' + disciplina + ' - TURMA ' + turma;

    turmas.push({
      turma_id: idTurma,
      nome: codigo + '-' + turma,
      nome_disciplina: disciplina,
      nome_curso: curso,
      turma_ano: turmaAno,
      turma_periodo: turmaPeriodo
    });
    turmasInclusas.push(turmaInclusa);

    $(this).hide();
    $(this).siblings('.btn-remove-ambiente').show();
    $('#nome-ambiente').val(getNomeAmbiente());
    $('#turmas-inclusas').val(turmasInclusas.join("\n"));
    $('#configuracao-ambiente').removeClass('hide');
    $('#configuracao-ambiente').addClass('show');
  });

  $('.btn-remove-ambiente').on('click', function() {
    const disciplina = $(this).data('disciplina');
    const codigo = $(this).data('codigo');
    const turma = $(this).data('turma');
    const idTurma = $(this).data('id-turma');
    const turmaAno = $(this).data('turma-ano');
    const turmaPeriodo = $(this).data('turma-periodo');
    const turmaInclusa = turmaAno + '.' + turmaPeriodo + ' - ' + codigo + ' - ' + disciplina + ' - TURMA ' + turma;

    turmasInclusas = turmasInclusas.filter(turma => turma !== turmaInclusa);
    turmas = turmas.filter(turma => turma.turma_id !== idTurma);

    $(this).hide();
    $(this).siblings('.btn-add-ambiente').show();
    $('#nome-ambiente').val(getNomeAmbiente());
    $('#turmas-inclusas').val(turmasInclusas.join("\n"));

    if (turmasInclusas.length === 0) {
      $('#configuracao-ambiente').removeClass('show');
      $('#configuracao-ambiente').addClass('hide');
    }
  });

  $('#modal-confirmacao').on('show.bs.modal', function() {
    $('#modal-nome-ambiente').text(getNomeAmbiente());
    $('#modal-turmas-inclusas').text(turmasInclusas.join("\n"));
  });

  $('#ambiente-form').on('submit', function() {
    const anoPeriodo = $('#ano_periodo').text();

    $('input[name="nome_ambiente"]').val(anoPeriodo + ' - ' + getNomeAmbiente());
    $('input[name="nome_breve"]').val(getNomeBreve());
    $('input[name="turmas"]').val(JSON.stringify(turmas));

    if ($('#notifica-usuarios').length > 0) {
      $('input[name="notifica_usuarios"]').val($('#notifica-usuarios').prop('checked') ? 1 : 0);
    }
  });

  if ($('#tabela-solicitacoes').length > 0) {
    const idIntervalo = setInterval(() => {
      $.get('/sicam/ambientes/status', (response) => {
        if (response.length === 0) {
          clearInterval(idIntervalo);
          window.location.reload(true);
        }

        response.forEach((data) => {
          const { id, status } = data;
          const element = $('#solicitacao-' + id);

          if (element.length > 0) {
            $('#solicitacao-' + id).text(status);
          }
        });
      });
    }, 3000);
  }
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
